import React from 'react';
import Modal from 'shared/components/modal';
import req from 'shared/req';

interface RejectTermsOfUseModalProps {
  onGoBackClick: () => void;
}

const RejectTermsOfUseModal = ({onGoBackClick}: RejectTermsOfUseModalProps) => {
  const deleteUser = (): Promise<void> =>
    req({
      url: '/v1/users/me',
      data: {reason: 'did not confirm terms of use'},
      method: 'delete',
    }).then(() => {
      window.location.href = '/';
    });

  return (
    <Modal show>
      <Modal.TextHeader>Are you sure?</Modal.TextHeader>
      <Modal.Body>
        <p>By deleting your account, you will:</p>
        <ul>
          <li>
            Lose access to <strong>ALL</strong> your Raise Me scholarships
          </li>
          <li>Lose access to your Raise Me portfolio</li>
          <li>No longer have your progress shared with colleges</li>
        </ul>
        <p>
          <strong>This cannot be undone.</strong>
        </p>
      </Modal.Body>
      <Modal.Footer
        primaryButton={{
          text: 'PERMANENTLY DELETE MY ACCOUNT',
          color: 'red',
          onClick: deleteUser,
        }}
        secondaryButton={{
          text: 'Go back',
          color: 'blue',
          rightAligned: true,
          onClick: onGoBackClick,
        }}
      />
    </Modal>
  );
};

export default RejectTermsOfUseModal;
